import { createRouter, createWebHistory } from 'vue-router';

// import Home from '@/components/HelloWorld';

const routes  = [
    {
        path: '/',
        name: '控制台',
        meta:{
            title: '控制台'
        },
        hidden: true,
        component: ()=>import('@/view/home/Index')
    },
    {
		path: '/login',
		name: '登录页面',
		meta:{
			title: '登录'
		},
		hidden: true,
        component: ()=>import('@/view/login/Index')
	}


];


const router = createRouter({
    history: createWebHistory(process.env.ROUTER_MODE),
    routes
});
export {router, routes};